import React__default, { Children, isValidElement, cloneElement } from 'react';
import styled, { css } from 'styled-components';
import { B as Breadcrumb } from './Breadcrumb-BoIJP2H2.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const Nav = /*#__PURE__*/styled.nav.withConfig({
  componentId: "sc-storm-ui-40026394__sc-1xvg9k0-0"
})(["font:", ";display:flex;flex-wrap:wrap;align-items:center;color:", ";gap:", ";", ""], ({
  theme
}) => theme.font.text.base.default, ({
  theme
}) => theme.text.color.secondary, ({
  theme
}) => theme.spacing.xxsmall.default, isMobile(css(["font:", ";gap:", ";"], ({
  theme
}) => theme.font.text.base.mobile, ({
  theme
}) => theme.spacing.xxsmall.mobile)));
const BreadcrumbGroup = ({
  children
}) => /*#__PURE__*/React__default.createElement(Nav, null, Children.map(children, (child, index) => {
  if (! /*#__PURE__*/isValidElement(child)) {
    return null;
  }
  if (child.type.name !== Breadcrumb.name) {
    return /*#__PURE__*/cloneElement(child, {
      // eslint-disable-next-line react/no-array-index-key
      key: index
    });
  }
  return /*#__PURE__*/cloneElement(child, {
    key: child.props.label,
    // Set isFinal to false as default so the angle-right icon renders for single breadcrumb
    isFinal: Array.isArray(children) ? index === children.length - 1 : false
  });
}));

export { BreadcrumbGroup as B };
//# sourceMappingURL=BreadcrumbGroup-C3Sjd4YE.js.map
